import React from 'react';

import styled from '@emotion/styled';

import mountainsPanel from '@images/checkout/challenger/mountains_panel.svg';

import { ChallengerFooter } from './footer';
import { MOBILE } from './media';
import { ChallengerNav, type ChallengerNavStep } from './nav';
import { CHALLENGER as T } from './tokens';

const Surface = styled.div`
  position: relative;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow-x: clip;
  background: ${T.color.bgPage};
  font-family: ${T.font.sans};
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;

/** Figma 707:21173 — fixed to the window; decorative, no pointer events. */
const MountainPanel = styled.img`
  position: fixed;
  bottom: 0;
  right: ${T.layout.mountainPanel.right};
  width: ${T.layout.mountainPanel.width};
  height: ${T.layout.mountainPanel.height};
  max-width: none;
  object-fit: contain;
  object-position: right bottom;
  pointer-events: none;
  user-select: none;
  z-index: 0;

  ${MOBILE} {
    right: -38%;
    width: min(120vw, 520px);
    height: auto;
  }
`;

const Chrome = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 100vh;
`;

const Main = styled.div`
  flex: 1 1 auto;
`;

type Props = {
  step?: ChallengerNavStep;
  navVariant?: 'checkout' | 'password';
  children: React.ReactNode;
};

/** Chrome shared by challenger funnel pages (nav + footer). */
export const ChallengerLayout: React.FC<Props> = ({
  step = 'storage_plan',
  navVariant = 'checkout',
  children,
}) => (
  <Surface className={T.layout.surfaceClassName}>
    <MountainPanel
      src={mountainsPanel}
      alt=""
      aria-hidden="true"
      decoding="async"
    />
    <Chrome>
      <ChallengerNav step={step} variant={navVariant} />
      <Main>{children}</Main>
      <ChallengerFooter />
    </Chrome>
  </Surface>
);
